import { Modal, Backdrop, Fade, Box } from "@mui/material";
import HeaderBar from "./HeaderBar";
import { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import { useData } from "./MemberData";
import Cookies from "js-cookie";
import '../../styles/style.css'
import Swal from "sweetalert2";
import axios from "axios";

interface TreasuryLogs{
    type: string;
    amount: number;
    callsign: number;
    reason: string;
    fromCS: number;
    timestamp: string;
}

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function ChestPage() {
    const { getPoliceDiscordMemberInfo, getPoliceMemberInfo } = useData();
    const [ModalOpen, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [cFrom, setFrom] = useState('');
    const [modalType, setType] = useState('');
    const [totalVisterie, setVisterie] = useState(0);
    const [visterieLogs, setLogs] = useState<TreasuryLogs[]>([]);

    async function setBani() {
        try {
            const response = await axios.get(`${API_URL}/visterie/get`);
            if (response && response.data) {
                setVisterie(response.data[0].money || 0);
            } else {
                toast.error("A apărut o eroare! Visteria nu a fost încărcată!");
            }
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Visteria nu a fost încărcată!");
        }
    
        try {
            const response = await axios.get(`${API_URL}/visterie/getHistory`);
            if (response) {
                if (response.data) {
                    setLogs(response.data.reverse());
                } else {
                    setLogs([]);
                }
            } else {
                toast.error("A apărut o eroare! Istoricul visteriei nu a fost încărcat!");
                setLogs([]);
            }
        } catch (error) {
            console.log(error);
            toast.error("A apărut o eroare! Istoricul visteriei nu a fost încărcat!");
        }
    }
    

    useEffect(() => {
        setBani()
    }, []);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        height: '55%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#191919',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 2,
    };

    const handleOpenModal = (tip: string) => {
        setType(tip)
        setOpen(true);
    }
    
    const handleClose = () => {
        setOpen(false);
    }

    function getRomaniaDateTime() {
        const options = { timeZone: "Europe/Bucharest", hour12: false };
        const now = new Date();
    
        const day = now.toLocaleString("en-GB", { ...options, day: "2-digit" });
        const month = now.toLocaleString("en-GB", { ...options, month: "2-digit" });
        const year = now.toLocaleString("en-GB", { ...options, year: "numeric" });
    
        const hours = now.toLocaleString("en-GB", { ...options, hour: "2-digit" });
        const minutes = now.toLocaleString("en-GB", { ...options, minute: "2-digit" });
    
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    }

    const addMoney = async () => {
        const callsign = getPoliceDiscordMemberInfo(Cookies.get("myDiscordID") || '', "callsign");
        handleClose();
        const parsedAmount = Number(amount) || 0;
        const result = await Swal.fire({
            title: `Ești sigur că vrei să adaugi suma de ${parsedAmount} din visterie?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });

                    
        if (!result.isConfirmed) {
            toast.success("Ai anulat acțiunea de adăugare bani din visterie!");
            return;
        } else {
            try {
                const response = await makeAuthenticatedRequest(`${API_URL}/visterie/createLog`, {
                    type: "ADĂUGARE",
                    amount: parsedAmount,
                    callsign: callsign,
                    reason: reason,
                    from_callsign: cFrom,
                    timestamp: getRomaniaDateTime()
                })
                   
                if (response.statusText === "OK") {
                    try {
                        const updatedMoney = (totalVisterie || 0) + parsedAmount;
                        const updateResponse = await makeAuthenticatedRequest(`${API_URL}/visterie/updateVisterie`, {
                            money: updatedMoney,
                            type: "ADĂUGARE",
                            full_name: getPoliceMemberInfo(callsign, "full_name"),
                            callsign: cFrom,
                            reason: reason,
                            amount: parsedAmount
                        })

                        if (updateResponse.statusText === "OK") {
                            setBani()
                            handleClose()
                            setAmount("")
                            setReason("")
                            setFrom("")
                            toast.success("Ai adăugat bani în visterie!");
                            setBani();
                        }
                    } catch (err: any) {
                        if (err.response.data.error === "Invalid token") {
                            toast.error("Token invalid! Te rugăm să te reconectezi.");
                            localStorage.removeItem("token");
                        } else {
                            toast.error("A apărut o eroare! Istoricul visteriei nu s-a încărcat.")
                        }
                    }
                }
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Banii nu au fost adăugați în visterie.");
                }
            }
        }
    };
    
    const removeMoney = async () => {
        const callsign = getPoliceDiscordMemberInfo(Cookies.get("myDiscordID") || '', "callsign");
        handleClose();
        const parsedAmount = Number(amount) || 0;
        const result = await Swal.fire({
            title: `Ești sigur că vrei să scoți suma de ${parsedAmount} din visterie?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });

                    
        if (!result.isConfirmed) {
            toast.success("Ai anulat acțiunea de adăugare bani din visterie!");
            return;
        } else {
            try {
                const response = await makeAuthenticatedRequest(`${API_URL}/visterie/createLog`, {
                    type: "SCOATERE",
                    amount: parsedAmount,
                    callsign: callsign,
                    reason: reason,
                    from_callsign: cFrom,
                    timestamp: getRomaniaDateTime()
                })
                   
                if (response.statusText === "OK") {
                    try {
                        const updatedMoney = (totalVisterie || 0) - parsedAmount;
                        const updateResponse = await makeAuthenticatedRequest(`${API_URL}/visterie/updateVisterie`, {
                            money: updatedMoney,
                            type: "SCOATERE",
                            full_name: getPoliceMemberInfo(callsign, "full_name"),
                            callsign: cFrom,
                            reason: reason,
                            amount: parsedAmount
                        })

                        if (updateResponse.statusText === "OK") {
                            setBani()
                            handleClose()
                            setAmount("")
                            setReason("")
                            setFrom("")
                            toast.success("Ai scos bani din visterie!");
                            setBani();
                        }
                    } catch (err: any) {
                        if (err.response.data.error === "Invalid token") {
                            toast.error("Token invalid! Te rugăm să te reconectezi.");
                            localStorage.removeItem("token");
                        } else {
                            toast.error("A apărut o eroare! Istoricul visteriei nu s-a încărcat.")
                        }
                    }
                }
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Banii nu au fost scoși din visterie.");
                }
            }
        }
    };

    const deleteHistory = async () => {
        const result = await Swal.fire({
            title: `Ești sigur că vrei să ștergi istoricul din visterie?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
                    
        if (!result.isConfirmed) {
            toast.success("Ai anulat acțiunea de ștergere istoric!");
            return;
        } else {
            try {
                const response = await makeAuthenticatedRequest(`${API_URL}/visterie/deleteHistory`, {});
                if (response.statusText === "OK") {
                    toast.success("Istoricul a fost șters!")
                    setLogs([]);
                } else {
                    toast.error("A apărut o eroare! Istoricul nu a fost șters.")
                    return;
                }
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Istoricul nu a fost șters.")
                }
            }
        }
    }

    return (
        <div className="dark w-full h-full flex flex-col gap-3 box-border">
            <HeaderBar currentPage="Visterie"/>
            <div className="w-[98%] h-[84%] flex gap-[2%] flex-col items-center box-border">
                <span className="textBold text-[2vw] text-white">VISTERIE</span>
                <div className="w-[40%] h-[40%] bg-[#ffffff10] border border-[#ffffff20] rounded-[.5vw] flex flex-col items-center box-border px-[1%]">
                    <span className="mt-[2%] textMedium text-white text-[1.5vw]">Total bani</span>
                    <span className={`mt-[3%] textExtraBold text-[3vw] ${Number(totalVisterie) > 0 ? "text-[#18c900]" : "text-[#c90000]"} blur-[2vw] hover:blur-0 transition-all`}>{totalVisterie.toLocaleString('de-DE')}$</span>
                    <div className="mt-[5%] w-[75%] h-[25%] flex flex-row items-center justify-between">
                        <div onClick={() => handleOpenModal('add')} className="w-[49%] h-full flex items-center bg-gradient-to-r from-[#19c20e] to-[#3bdb16] justify-center rounded-[.5vw] cursor-pointer">
                            <span className="textSemiBold text-[1.5vw] text-white">ADAUGĂ</span>
                        </div>
                        <div onClick={() => handleOpenModal('rmv')} className="w-[49%] h-full flex items-center bg-gradient-to-r from-[#c20e0e] to-[#f51818] justify-center rounded-[.5vw] cursor-pointer">
                            <span className="textSemiBold text-[1.5vw] text-white">SCOATE</span>
                        </div>
                    </div>
                </div>
                <div className="w-full h-fit flex items-center justify-center gap-[2%]">
                    <span className="textBold text-[2vw] text-white">ISTORIC</span>
                    <div onClick={deleteHistory} className="px-[2%] py-[0.5%] cursor-pointer flex items-center justify-center rounded-[.5vw] bg-gradient-to-b from-[#c20e0e] to-[#f51818]">
                        <span className="textMedium text-white text-[1vw]">Șterge Istoric</span>
                    </div>
                </div>
                <div className="w-[60%] h-[40%] flex flex-col items-center justify-center box-border bg-[#605D5D61] gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                    <div className="bg-[#323232] w-[98%] h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                        {visterieLogs.map((data, index) => (
                            <div key={index} className="w-full min-h-[18%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]">
                                <span className={`textSemiBold w-fit text-center ${data.type === "ADAUGARE" ? 'text-[#19c20e]' : 'text-red-500'} text-[0.9vw]`}>{data.type}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-white text-[0.9vw]">{data.amount.toLocaleString('de-DE')}$</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-white text-[0.9vw]">[{String(data.callsign).padStart(3, '0')}]</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-white text-[0.9vw]">{data.reason}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <span className="textSemiBold w-fit text-center text-[#808080] text-[0.8vw]">{data.timestamp}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={ModalOpen}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={ModalOpen}>
                <Box sx={style} className="flex flex-col items-center">
                    {modalType === "add" ? (
                        <span className="text-white textSemiBold text-[1vw] w-full text-center">ADĂUGARE BANI VISTERIE</span>
                    ): (
                        <span className="text-white textSemiBold text-[1vw] w-full text-center">SCOATERE BANI VISTERIE</span>
                    )}
                    <input
                        onChange={e => setAmount(e.target.value)}
                        placeholder="Suma"
                        type="number"
                        className="w-[60%] h-[14%] mt-[3%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    <input
                        onChange={e => setReason(e.target.value)}
                        placeholder="Motiv"
                        type="text"
                        className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    {modalType === "add" ? (
                        <input
                            onChange={e => setFrom(e.target.value)}
                            placeholder="Link Amendă/Sursă"
                            type="text"
                            className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                        />
                    ) : (
                        <input
                            onChange={e => setFrom(e.target.value)}
                            placeholder="Link Amendă/Sursă"
                            type="text"
                            className="w-[60%] h-[14%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                        />
                    )}
                    {modalType === "add" ? (
                        <div onClick={addMoney} className="cursor-pointer mt-[10%] w-[70%] h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                            <span className="text-white textBold text-[1vw]">ADAUGĂ</span>
                        </div>
                    ) : (
                        <div onClick={removeMoney} className="cursor-pointer mt-[10%] w-[70%] h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                            <span className="text-white textBold text-[1vw]">SCOATE</span>
                        </div>
                    )}
                </Box>
                </Fade>
            </Modal>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
    )
}

export default ChestPage;